import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './types';

export type UiSliceObject = {
  preventsBiomtericsPrompt: boolean;
  /**
   * Monotonic counter used to imperatively open the header location picker
   * from elsewhere (e.g. the activation tracker's "Visit test location" task).
   * The LocationPicker presents its sheet whenever this value increases.
   */
  locationPickerOpenRequest: number;
};

const initialState: UiSliceObject = {
  preventsBiomtericsPrompt: false,
  locationPickerOpenRequest: 0,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setPreventsBiomtericsPrompt: (state, action: PayloadAction<boolean>) => {
      state.preventsBiomtericsPrompt = action.payload;
    },
    requestOpenLocationPicker: state => {
      state.locationPickerOpenRequest += 1;
    },
  },
});

export const { setPreventsBiomtericsPrompt, requestOpenLocationPicker } =
  uiSlice.actions;

export const selectUi = (state: RootState) => state.ui;
export const selectPreventsBiomtericsPrompt = (state: RootState) =>
  state.ui.preventsBiomtericsPrompt;
export const selectLocationPickerOpenRequest = (state: RootState) =>
  state.ui.locationPickerOpenRequest;

export default uiSlice.reducer;
